// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__cLUY5","rightAdornment":"Header_rightAdornment__1j-Dc"};